import React from "react";
import summaryIcon from "../assets/summary.png";
import { formatarValor } from "./OrderTable";

const CostOverview = ({
  title,
  order,
  valuePrevisto,
  valueRealizado,
  diferenca,
}) => {
  return (
    <>
      <div className="bg-[#F9F9F9] my-4 md:py-2 lg:p-4 flex">
        <div className="w-full text-[#2F2E41] opacity-80 flex">
          <div className="py-2 text-[#2F2E41] opacity-80 flex flex-grow">
            <div className="flex justify-center items-center md:px-2 px-4">
              <img
                className="md:w-[40px] md:h-[50px] lg:w-[50px] lg:h-[60px] "
                src={summaryIcon}
                alt=""
              />
            </div>
            <div className="lg:w-[342px] cursor-pointer md:ml-2 xl:ml-4">
              <p className="md:text-base lg:text-2xl">{title}</p>
              <p className="md:text-base lg:text-3xl  font-bold">{order}</p>
            </div>
          </div>

          <div className="text-center flex justify-around items-center md:flex-grow lg:w-[516px] ">
            <div>
              <div>
                <p className="uppercase text-[#FF9533] font-bold">Previsto</p>
              </div>
              <div>
                <p className="text-base">
                  {formatarValor(valuePrevisto, "BRL")}
                </p>
              </div>
            </div>
            <div>
              <div>
                <p className="uppercase text-[#FF9533] font-bold">Realizado</p>
              </div>
              <div>
                <p className="text-base">
                  {formatarValor(valueRealizado, "BRL")}
                </p>
              </div>
            </div>
            <div>
              <div>
                <p className="uppercase text-[#FF9533] font-bold">
                  Realizado - previsto
                </p>
              </div>
              <div>
                <p className="text-base">{formatarValor(diferenca, "BRL")}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CostOverview;
